module.exports = __webpack_public_path__ + "img/block.d0901845.svg";